import React from 'react'
import { connect } from 'react-redux'
import Card, { TitleCard, CardHeader } from '../../core/Card'
import './TaxCenter.css'
import { DatePicker, Button, Row, Col } from 'antd';
import { onRangeChange } from './actions'
import numeral from 'numeral';
import moment from 'moment'

const { MonthPicker, RangePicker } = DatePicker;

const rangePickerRanges = {
  Today: [moment(), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  'This Year': [moment().startOf('year'), moment().endOf('year')],
  'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
}

const TaxCenter = ({totals, range, taxableIncome, onRangeChange}) =>
  <div className="TaxCenter">
    <TitleCard>
      <h1>Tax Center</h1>
      <div/>
    </TitleCard>
    <Card>
      <CardHeader
        title="Standard Method Overview"
        customActionComponent={
          <RangePicker
            ranges={rangePickerRanges}
            format={'MM/DD/YYYY'} allowClear={false} defaultValue={range} onChange={onRangeChange}/>
        }
      />
      <div className="summary-table">
        <Row className="" type="flex" justify="space-between" align="middle">
          <Col span={12}>
            Revenue
          </Col>
          <Col span={12}>
            <span className="amount positive">{numeral(totals.total_revenue).format('($0,0.00)')}</span>
          </Col>
        </Row>
        <Row className="" type="flex" justify="space-between" align="middle">
          <Col span={12}>
            Work Expenses
          </Col>
          <Col span={12}>
            <span className="amount negative">{numeral(totals.total_expenses).format('($0,0.00)')}</span>
          </Col>
        </Row>
        <Row className="" type="flex" justify="space-between" align="middle">
          <Col span={12}>
            Mileage Deduction
          </Col>
          <Col span={12}>
            <span className="amount negative">{numeral(totals.total_trips_deductions).format('($0,0.00)')}</span>
          </Col>
        </Row>
        <hr/>
        <Row className="" type="flex" justify="space-between" align="middle">
          <Col span={12}>
            Taxable Income
          </Col>
          <Col span={12}>
            <span className="amount">{numeral(taxableIncome).format('($0,0.00)')}</span>
          </Col>
        </Row>
      </div>
    </Card>
    
  </div>

export default connect(({account})=>({...account.taxCenter}), { onRangeChange })(TaxCenter)



// WEBPACK FOOTER //
// ./src/account/tax-center/TaxCenter.js